<template>
    <v-flex fill-height>
        <sidemainmenu/>
        <br />
        <v-progress-linear color="red" slot="extension" :indeterminate="true"  v-if="loading" class="ma-0"></v-progress-linear>
        <v-alert :value="alertsuccess" color="success" icon="new_releases">
                {{ alertsmessage }}
        </v-alert>
        <v-alert :value="alerterror" color="error" icon="new_releases">
            <ul>
                <li v-for="error in errors">{{ error }}</li>
            </ul>
        </v-alert>
        <v-layout wrap justify-space-between>
            <v-card  class="mx-auto" min-width="100%">
            <v-card-title>
                <v-layout wrap justify-space-between>
                    <v-flex xs12 md2>
                        <v-text-field v-model="txtBLNo" label="Search By BL No."></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm8 class="py-2">
                        <v-btn color="info" v-on:click="getData()">
                            <span>Search</span>
                            <v-icon>search</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex xs12 md2>
                    </v-flex>
                </v-layout>
            </v-card-title>
            <v-card-text>
                <v-card v-if="seen">
                    <v-card-title>
                        <h3 class="py-4">Delivery Report</h3>
                        <export-excel
                            title = "VCFS Import Delivery Report"
                            :data   = "delivery_details">
                            <v-btn color="cyan">
                            <v-icon color="white">file_copy</v-icon>
                        </v-btn>
                        </export-excel>
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                    </v-card-title>
                    <v-data-table :headers="headers" :items="delivery_details" :search="search" class="elevation-1" :rows-per-page-items="[100, 500, 1000, 5000]">
                        <template v-slot:items="props">
                            <tr>
                                <td>{{ props.index + 1 }}</td>
                                <td class="text-xs-right">{{ props.item.cha }}</td>
                                <td class="text-xs-right">{{ props.item.importer }}</td>
                                <td class="text-xs-right">{{ props.item.line }}</td>
                                <td class="text-xs-right">{{ props.item.vessel }}</td>
                                <td class="text-xs-right">{{ props.item.voyage }}</td>
                                <td class="text-xs-right">{{ props.item.containerno }}</td>
                                <td class="text-xs-right">{{ props.item.sizetype }}</td>
                                <td class="text-xs-right">{{ props.item.passno }}</td>
                                <td class="text-xs-right">{{ props.item.truckno }}</td>
                                <td class="text-xs-right">{{ props.item.outdate }}</td>
                                <td class="text-xs-right">{{ props.item.sealno }}</td>
                                <td class="text-xs-right">{{ props.item.status }}</td>
                            </tr>
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                Your search for "{{ search }}" found no results.
                            </v-alert>
                        </template>
                    </v-data-table>
                </v-card>
            </v-card-text>
            </v-card>
        </v-layout>
    <br />
    <bottomfootermenus/>
    </v-flex>
</template>


<script>
import sidemainmenu from '@/components/header.vue';
import bottomfootermenus from '@/components/footer.vue';
import axios from 'axios';
    const toLower = text => {
            return text.toString().toLowerCase()
        }

        const searchByName = (items, term) => {
            if (term) {
              return items.filter(item => toLower(item.name).includes(toLower(term)))
            }

            return items
        }
  export default {
    name: 'conthistorylist',
    data() {
        return {
            error: false,
            valid: false,
            alerterror: false,
            alertsuccess: false,
            alertsmessage: null,
            errors: null,
            seen: true,
            search: null,
            txtBLNo: null,
            delivery_details: [],
            twenties: 0,
            fourties: 0,
            activeVal: "Open",
            loading: false,
            crossDomain : true,
            xhrFields: {
                withCredentials: true
            },
            headers: [
                { text: 'S.No', sorting: false, align: 'left' },
                { text: 'CHA', align: 'left', value: 'cha' },
                { text: 'Importer', align: 'left', value: 'importer' },
                { text: 'Line', align: 'right', value: 'line' },
                { text: 'Vessel', align: 'right', value: 'vessel' },
                { text: 'Voyage', align: 'right', value: 'voyage' },
                { text: 'Container No.', align: 'right', value: 'containerno' },
                { text: 'Size', align: 'right', value: 'sizetype' },
                { text: 'Pass No', align: 'right', value: 'passno' },
                { text: 'Truck No', align: 'right', value: 'truckno' },
                { text: 'Out Date', align: 'right', value: 'outdate' },
                { text: 'Seal No.', align: 'right', value: 'sealno' },
                { text: 'Status', align: 'right', value: 'status' }
            ]
        }
    },
    mounted:function(){
    },
    components: {
        sidemainmenu,
        bottomfootermenus,
    },
    methods: {
        getData: function () {
            this.loading = true;
            if(this.txtBLNo !== null) {
                this.API_URL = this.$hostname + "/reports/delivery?bl_no="+ this.txtBLNo
            } else {
                alert("Enter BL Number");
            }
            axios.get(this.API_URL, { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
            .then((response) => {
                this.loading = false;
                this.delivery_details = response.data.data;
                this.twenties = response.data.twenties;
                this.fourties = response.data.fourties;
            }, (error) => {
                this.loading = false;
                this.error = error.response.statusText;
                alert(this.error);
            })
        },
        searchOnTable () {
            this.state = searchByName(this.state, this.search)
        }
    }
  }
</script>

<style lang="stylus" scoped>
      .v-progress-circular
        margin: 1rem
    .loading-overlay
        z-index: 10
        top: 0
        left: 0
        right: 0
        position: absolute
        width: 100%
        height: 100%
        background: rgba(255, 255, 255, 0.9)
        display: flex
        align-items: center
        justify-content: center

</style>
